<template>
    <div class="container-fluid d-flex flex-column">
        <div class="row justify-content-center min-vh-100">
            <div class="col-md-6 col-lg-5 col-xl-4 py-6 py-md-0 mt-5">
                <FullscreenLoading v-if="isLoadingInvite || isLoading" />

                <div class="card" style="max-width: 600px; margin: 0 auto;" v-if="!isLoadingInvite">
                    <div class="d-flex justify-content-end mr-2 mt-1">
                        <LanguageSwitcher />
                    </div>

                    <div class="card-body">
                        <div class="card-header"></div>

                        <div>
                            <div class="mb-5 text-center">
                                <img v-if="companyAssets" style="width: 150px;" :src="companyAssets + '/logo.png'">
                                <img v-else style="height: 140px;" :src="require('../../assets/lite/Logo-Text-Below.svg')" />
                            </div>

                            <span class="clearfix"></span>

                            <div v-if="foundInvite">
                                <p class="text-center">{{ $t('user_invite.description', { name: foundInvite.invited_by, company: foundInvite.company }) }}</p>

                                <AcceptUserInviteForm
                                    form-id="accept-invite-form"
                                    @submit="acceptUserInvite"
                                />

                                <div class="mt-4">
                                    <button type="submit" form="accept-invite-form" class="btn btn-block btn-primary">
                                        {{ $t('user_invite.accept') }}
                                    </button>
                                </div>

                                <div class="alert alert-danger mt-5" v-if="errors?.length">
                                    <ul>
                                        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                                    </ul>
                                </div>
                                <div class="alert alert-danger mt-5" v-if="errorMessage">
                                    {{ errorMessage }}
                                </div>
                            </div>

                            <div v-else class="alert alert-danger">
                                {{ $t('user_invite.invite_not_found') }}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

    import { computed, inject, onMounted, ref } from 'vue';
    import LanguageSwitcher from '../../components/LanguageSwitcher.vue';
    import { useRoute, useRouter } from 'vue-router/composables';
    import { notifyError } from '../../utils/notify';
    import i18n from '../../utils/locale';
    import FullscreenLoading from '../../components/FullscreenLoading.vue';
    import AcceptUserInviteForm from '../../forms/AcceptUserInviteForm.vue';

    const router = useRouter();
    const route = useRoute();
    const http = inject('http');
    const store = inject('store');

    const errorMessage = ref(null);
    const errors = ref([]);
    const isLoading = ref(false);
    const isLoadingInvite = ref(false);
    const foundInvite = ref(null);

    const companyAssets = computed(() => {
        return window.COMPANY_ASSETS;
    });

    onMounted(() => {
        loadUserInvite();
    });

    async function loadUserInvite() {
        isLoadingInvite.value = true;

        try {
            const response = await http.get('/api/user-invites/' + route.params.code);
            foundInvite.value = response.data;
        } catch (exception) {
            notifyError(exception);
        } finally {
            isLoadingInvite.value = false;
        }
    }

    async function acceptUserInvite(data) {
        errors.value = null;
        errorMessage.value = null;
        isLoading.value = true;

        try {
            const { name, password } = data;

            const response = await http.post('/api/user-invites/' + route.params.code + '/accept', {
                name,
                password,
            });

            await store.dispatch('login', {
                user: response.data.user,
                token: response.data.token,
            });

            if (store.getters.hasPermission('viewCeremonies')) {
                if (window.IS_LITE_VERSION) {
                    await router.push({ name: 'welcome' });
                } else {
                    await router.push('/ceremonies');
                }
            } else if (store.getters.hasPermission('manageSongs')) {
                await router.push('/songs');
            } else {
                if (window.IS_LITE_VERSION) {
                    await router.push({ name: 'welcome' });
                }
            }
        } catch (exception) {
            isLoading.value = false;

            if (exception?.response?.status === 422) {
                errors.value = Object.values(exception?.response?.data?.errors).flat();
            } else {
                errorMessage.value = i18n.t('general.unexpected_error');
            }
        }
    }
</script>
